import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeIt);

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.oidc.userPoolId,
      userPoolClientId: environment.oidc.userPoolClientId,
      loginWith: {
        oauth: {
          domain: environment.oidc.domain,
          scopes: environment.oidc.scopes,
          redirectSignIn: environment.oidc.redirectSignIn,
          redirectSignOut: environment.oidc.redirectSignOut,
          responseType: 'code',
        },
      },
    },
  },
});

bootstrapApplication(App, appConfig).catch(err => console.error(err));
